module.exports = __webpack_public_path__ + "img/senior_card.625324e2.png";